import React, { useState } from 'react';
import { Accordion } from './Accordion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number>(-1);
  const faqs = [{
    q: '¿Sirve si recién arranco como profesor de LSA?',
    a: 'Sí. El sistema empieza desde cero absoluto con progresión didáctica clara. Es el punto de partida ideal para organizar tus primeras clases de manera profesional desde el día uno.'
  }, {
    q: '¿Puedo usarlo si ya tengo experiencia dando clases?',
    a: 'Absolutamente. El sistema te da material organizado, un diccionario visual completo y recursos para optimizar tus clases actuales sin cambiar lo que ya te funciona.'
  }, {
    q: '¿El material está adaptado al LSA argentino?',
    a: '100%. Todo basado en el Lenguaje de Señas Argentino actualizado a 2026, con variaciones regionales incluidas. No es material genérico ni traducido de otro país.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Acceso inmediato después del pago. Todo digital — usalo desde tu celular, tablet o computadora. También podés imprimirlo para tus clases.'
  }, {
    q: '¿Puedo compartir el material con mis alumnos?',
    a: 'El material es de uso personal del profesor. Podés usarlo como base de tus clases pero no redistribuirlo ni compartirlo digitalmente.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días sin preguntas. Si no es lo que esperabas, nos escribís y te devolvemos el 100%. Menos del 1% de quienes compran pide devolución.'
  }];
  return <section className="bg-lsa-light text-lsa-dark py-12 px-5" data-id="element-64">
      <div className="max-w-xl mx-auto" data-id="element-65">
        <h2 className="text-[28px] font-bold text-center mb-8 leading-tight" data-id="element-66">
          Lo que más nos preguntan
        </h2>

        <div data-id="element-67">
          {faqs.map((faq, index) => <Accordion key={index} theme="light" isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? -1 : index)} title={faq.q} data-id="element-68">
              <div className="pt-1 pb-2" data-id="element-69">
                <p className="text-[15px] text-lsa-dark/80 leading-relaxed" data-id="element-70">
                  {faq.a}
                </p>
              </div>
            </Accordion>)}
        </div>
      </div>
    </section>;
}